import CustomerQuoteResponse from "../../../classes/CustomerQuoteResponse";
import { db, storage } from "../../../boot/firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
} from "firebase/storage";

export const GET_CUSTOMER_QUOTE_RESPONSE = async (
  { dispatch },
  { customerID, quoteID, id }
) => {
  let path = CustomerQuoteResponse.getPath(customerID, quoteID, id);
  return dispatch("GET_DOC", {
    converter: CustomerQuoteResponse,
    path,
    stateKey: "customerQuoteResponses",
    stateID: CustomerQuoteResponse.getStateID(path),
  });
};

export const GET_CUSTOMER_QUOTE_RESPONSES = (
  { dispatch },
  { customerID, quoteID, conditions, limitCount, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: CustomerQuoteResponse,
    stateKey: "customerQuoteResponses",
    path:
      customerID && quoteID
        ? CustomerQuoteResponse.getPath(customerID, quoteID)
        : null,
    conditions,
    limitCount,
    pagination,
  });
};

export const LISTEN_CUSTOMER_QUOTE_RESPONSE = async (
  { dispatch },
  { customerID, quoteID, id, next, error, unlisten }
) => {
  return dispatch("LISTEN_DOC", {
    converter: CustomerQuoteResponse,
    path: CustomerQuoteResponse.getPath(customerID, quoteID, id),
    stateKey: "customerQuoteResponses",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_CUSTOMER_QUOTE_RESPONSES = async (
  { dispatch },
  { customerID, quoteID, conditions, pagination, next, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: CustomerQuoteResponse,
    stateKey: "customerQuoteResponses",
    path:
      customerID && quoteID
        ? CustomerQuoteResponse.getPath(customerID, quoteID)
        : null,
    conditions,
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SUBMIT_QUOTE_RESPONSE = async ({ state }, response) => {
  const path = response.path;

  // Responses are create-only (firestore.rules), so a second write to the
  // same response lands as a bare "Missing or insufficient permissions". The
  // usual cause is a response the customer already submitted that the
  // quoteResponse trigger never propagated, which leaves the quote looking
  // merely "Sent" in the app; say that instead of a permissions error.
  const existing = await getDoc(doc(db, path));
  if (existing.exists()) {
    throw "quoteResponseExists";
  }

  // Add submission info
  response.data.submitted = new Date();
  response.data.createdBy = state.user.id;

  if (response.data.pdf && response.data.pdf.toSave) {
    try {
      const ref = storageRef(storage, `${path}/${response.data.pdf.name}`);
      await uploadBytes(ref, response.data.pdf.toSave);
      const url = await getDownloadURL(ref);
      response.data.pdf.toSave = null;
      response.data.pdf.url = url;
    } catch (error) {
      console.error(error);
      throw "failedUploadingFiles";
    }
  }

  return setDoc(doc(db, path).withConverter(CustomerQuoteResponse), response);
};
